<template>
  <div class="brandIdBlock">
    <el-button type="primary" v-if="!batchBrand" @click="useBrandConf" style="margin-bottom: 10px">一键应用品牌配置</el-button>
    <!-- <pre>{{valueMap}}</pre> -->
    <el-input v-if="!batchBrand" width="200px" style="margin-left: 10px;" type="text" clearable placeholder="输入品牌,回车后匹配填充" v-model="inputBrandText" @keyup.enter.native="batchFillBrand"> </el-input>
    <el-form ref="formRef" :model="valueMap" :label-width="source !='batchDelete'? '360px':'180px'">
      <el-form-item v-for="item in shopBrandList" :key="item.shopId" :prop="String(item.shopId)" :rules="itemRules(item)">
        <span slot="label">
          <el-image :src="item.shopIcon" style="height: 16px; margin-right:5px"></el-image>
          <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px 6px 0px 6px;">
              <el-image :src="item.channelIcon" style="width: 18px; height: 18px;"></el-image>
          </el-tooltip>
          <span>{{ item.shopName }}</span>
        </span>
        <el-select
          :value="valueMap[item.shopId]"
          value-key="vid"
          name-key="vvalue"
          v-loading="loading[item.shopId]"
          filterable
          remote
          clearable
          :remote-method="$event => getBrandListBy($event, item.shopId)"
          @focus="() => selectFocus(item.shopId)"
          @change="v => selectChange(v, item.shopId)"
        >
          <template v-if="brandOptions[item.shopId]">
            <el-option v-for="(brandOp, opIndex) in brandOptions[item.shopId]" :key="brandOp.vid + opIndex" :label="brandOp.vvalue" :value="brandOp">
            </el-option>
          </template>
        </el-select>
         <el-link style="margin-left: 8px" @click="handleRefreshBrand(item)">刷新品牌</el-link>
         <el-link v-if="valueMap && valueMap[item.shopId] && valueMap[item.shopId].vvalue && !batchBrand"  style="margin-left: 8px" @click="handleSetToShop(item,valueMap[item.shopId].vvalue)">应用到其他店铺</el-link>
        <span v-if="getFail[item.shopId]" class="error-text">{{
          getFail[item.shopId] === true ? '店铺订购应用已过期，请重新订购以获取店铺品牌' : getFail[item.shopId]
        }}</span>
      </el-form-item>
      <!-- <div v-if="validateError" class="el-form-item__error">至少需要一个店铺填写品牌</div> -->
    </el-form>
    <el-dialog-select-shop
        :visible.sync="shopDialogVisible"
        :shopData="shopList"
        :selected="selectShopIds"
        placeholder="店铺名称"
        @confirm="confirmSelectShop"
    ></el-dialog-select-shop>

  </div>
</template>

<script>
import { getBrandListV2, refreshBrand, getShopsBrandFill, ApplyToOtherShop } from '@/servers/prod/center/fxg.js';
import { getPlatFormBrandList } from '@/api/prod/center'
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { getApplyBrandConfig } from '@/servers/prod/center/pdd.js';
const PLATFORMID = 'TouTiaoFXG';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    source: {
      type: String, //来源于详情还是批量删除页面，批量删除页面不需要默认根据店铺列表获取列表接口 batchDelete
      default() {
        return ''
      },
    },
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    baseItemId: [String, Number],
    categoryId: {
      required: true,
    },
    batchBrand: {
      type: Boolean,
      default() {
        return false
      }
    },
  },
  data() {
    return {
      inputBrandText: '',
      shopBrandList: [],
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
      shopDialogVisible:false,
      selectShopIds: '',
      applyShopName:'',//发货时效应用的店铺名称
      applyShopObj:[],//发货时效应用的店铺对象
      _isUpdatingFromValue: false, // 防止循环更新的标志位
      validateError: false, 
    };
  },
  computed: {
    ...mapGetters(['shops_getById']),
  },
  watch: {
    categoryId: {
      async handler(categoryId) {
        this.updateBrands(this.shopList);
        if (categoryId && this.shopList.length && this.source !='batchDelete') {
          await this.getBrandList();
          this.method_validate()
        }
      },
      immediate: true,
    },
    value: {
      immediate: true,
      handler(v) {
        // 防止循环更新
        this._isUpdatingFromValue = true;
        if (v && v.length) {
          // 清空现有的valueMap，避免残留数据
          this.valueMap = {};
          v.forEach(item => {
            this.$set(this.valueMap, item.shopId, item);
          });
        } else {
          // 当value为空时，清空valueMap
          this.valueMap = {};
        }
        this.$nextTick(() => {
          this._isUpdatingFromValue = false;
        });
      },
    },
    valueMap: {
      deep: true,
      handler(v) {
        // 如果是从value更新触发的，不再触发change事件，避免循环
        if (this._isUpdatingFromValue) {
          return;
        }
        let values = Object.values(v).map(item => {
          // 确保每个item都有完整的数据结构
          const completeItem = {
            vid: item.vid || '',
            vvalue: item.vvalue || '',
            categoryId: item.categoryId || this.categoryId,
            shopId: item.shopId,
            valueUnit: item.valueUnit || '',
            refPid: item.refPid || '',
            channel: this.shopList.find(shop => shop.id == item.shopId)?.channel || ''
          };
          return completeItem;
        });
        // 深拷贝values，避免父组件与子组件数据产生引用关系
        this.$emit('change', JSON.parse(JSON.stringify(values)));
      },
    },
    // shopList: {
    //   immediate: true,
    //   async handler(v) {
    //     if (!v) return;
    //     this.updateBrands(v);
    //     // 针对批量删除100条以上数据默认根据店铺列表获取接口导致卡顿，所以批量删除默认不获取 
    //     if (v.length > 0 && this.source !='batchDelete') {
    //       await this.getBrandList();
    //       this.method_validate()
    //     }
    //   }
    // },
  },
  methods: {
    itemRules(item) {
      const validShop = (rule, value, callback) => {
        if (!item.isRequired || !this.brandOptions[item.shopId]?.length) {
          return callback();
        }
        const itemValue = this.valueMap[item.shopId] || {};
        if (!itemValue.vid) {
          return callback(new Error('该类目下品牌必填，品牌为空不支持商品发布'));
        }
        return callback();
      };
      return [{ required: item.isRequired, validator: validShop }];
    },
    async updateBrands(data) {
      this.shopBrandList = data.map(item => {
        const findItem = this.value.find(v => v.shopId == item.id) || {};
        // 确保设置到valueMap的数据有完整的结构
        const completeItem = {
          vid: findItem.vid || '',
          vvalue: findItem.vvalue || '',
          categoryId: findItem.categoryId || this.categoryId,
          shopId: item.id,
          valueUnit: findItem.valueUnit || '',
          refPid: findItem.refPid || '',
          channel: item.channel || ''
        };
        this.$set(this.valueMap, item.id, completeItem);

        const shop = this.shops_getById(item.id) || {};
        return {
          shopId: item.id,
          userId: item.userId,
          shopName: shop.shortTitle || shop.title,
          shopIcon: shop.icon,
          channelIcon: shop.channelIcon,
          channelName: shop.channelName,
          // isRequired: item.isRequired,
        };
      });
    },
    selectFocus(shopId) {
      if (!this.brandOptions[shopId]) {
        this.getBrandListBy('', shopId);
      }
    },
    async getBrandListBy(query, shopId) {
      this.$set(this.getFail, shopId, null);
      this.$set(this.loading, shopId, true);
      try {
        const curShop = this.shopList.find(shop => shop.id == shopId);
        let data = await this.getBrandList({ query, shopId });;
        const brandList = (data || []).find(item => item.shopId == shopId)?.brandList || [];
        const options = brandList.map(item => ({ vid: item.vid, vvalue: item.name, shopId }));
        this.$set(this.brandOptions, shopId, options);
      } catch (error) {
        console.log(error, '-----error');
      } finally {
        this.$set(this.loading, shopId, false);
      }
    },
    async getBrandList(params = {}) {
      const data = await getBrandListV2({ categoryLeafId: this.categoryId, baseItemId: this.baseItemId, ...params });
      this.shopBrandList.forEach(item => {
        const shopId = item.shopId;
        let target = data.find(s => s.shopId == shopId);
        this.$set(item, 'isRequired', target ? target.isRequired : (item.isRequired || false));
        if(target?.brandList?.length) {
          let options = target.brandList.map(brand => ({ vid: brand.vid, vvalue: brand.name, shopId }));
          this.$set(this.brandOptions, shopId, options);
        }
      });
      return data;
    },
    selectChange(v, shopId) {
      // 构建完整的品牌项数据结构
      const completeItem = v ? {
        vid: v.vid || '',
        vvalue: v.vvalue || '',
        categoryId: v.categoryId || this.categoryId,
        shopId: shopId,
        valueUnit: v.valueUnit || '',
        refPid: v.refPid || '',
        channel: this.shopList.find(shop => shop.id == shopId)?.channel || ''
      } : {
        vid: '',
        vvalue: '',
        categoryId: this.categoryId,
        shopId: shopId,
        valueUnit: '',
        refPid: '',
        channel: this.shopList.find(shop => shop.id == shopId)?.channel || ''
      };
      
      this.$set(this.valueMap, shopId, completeItem);
    },
    method_validate() {
      return new Promise(resolve => {
        if(!this.$refs.formRef) return resolve(true);
        this.$refs.formRef.validate(valid => {
          resolve(valid);
        });
      });
      // this.validateError = false
      // const hasRequired = this.shopBrandList.some(v => v.isRequired)
      // if(hasRequired) {
      //     this.validateError = this.value.every(item => !item.vid)
      // }
      // return !this.validateError
    },
    async batchFillBrand() {
      const shopIds = this.shopList.map(shop => shop.id)
      const list = await getShopsBrandFill({brandName: this.inputBrandText, categoryId: this.categoryId, shopIds})
      list.forEach(item => {
        const { shopId, scmFxgBrand } = item;
        let newItem = {
          vid: scmFxgBrand.vid,
          vvalue: scmFxgBrand.name,
          shopId,
        };
        this.$set(this.valueMap, shopId, newItem);
      })
      
    },

    async useBrandConfInit() {
      const categoryId = this.categoryId;
      const categoryBrandRelations = await getApplyBrandConfig({ categoryId, baseItemId: this.baseItemId, shopType: PLATFORMID });
      let valueMap = {};
      let newVal = [];

      // 新增逻辑：检查是否有未匹配的 shopId  获取品牌设置数据
      const unmatchedShopIds = this.shopList
          .map(shop => shop.id)
          .filter(shopId => !categoryBrandRelations.some(item => item.shopId === shopId && item.relations.find(item=>item.categoryId == categoryId)));
      if (unmatchedShopIds.length > 0) {
          // 调用 getApplyToOtherShop 接口获取数据
          const res = await this.getApplyToOtherShop({
          shopType: PLATFORMID,
          shopIds: unmatchedShopIds.join(','),
          categoryId: (categoryId),
          });
          // 将返回的数据进行匹配
          unmatchedShopIds.forEach(shopId => {
          const shopData = res[shopId];
          if (shopData) {
              const newItem = {
                vid: shopData.vid,
                vvalue: shopData.vvalue,
                categoryId: shopData.categoryId,
                shopId: Number(shopId),
                valueUnit: shopData.valueUnit || '',
                refPid: shopData.refPid || '',
              };
              valueMap[shopId] = newItem;
              newVal.push(newItem);
          }
          });
      }

      // 获取类目外设置数据
      this.shopList.forEach(shop => {
          const shopId = shop.id;
          let relations = (categoryBrandRelations.find(item => shopId === item.shopId) || {}).relations || [];
          let valueItem = relations.find(item => item.categoryId == categoryId);
          if (valueItem) {
          let newItem = {
            vid: valueItem.vid,
            vvalue: valueItem.vvalue,
            categoryId: valueItem.categoryId,
            shopId: Number(shopId),
            valueUnit: valueItem.valueUnit || '',
            refPid: valueItem.refPid || '',
          };
          valueMap[shopId] = newItem;
          newVal.push(newItem);
          }
      });
      Object.keys(valueMap).forEach(shopId => {
          if (!valueMap[shopId]) {
          valueMap[shopId] = valueMap[shopId];
          newVal.push(valueMap[shopId]);
          }
      })
      this.$set(this, 'valueMap', valueMap);
      // 深拷贝newVal，避免父组件与子组件数据产生引用关系
      this.$emit('change', JSON.parse(JSON.stringify(newVal)));
    },
    async useBrandConf() {
      const categoryId = this.categoryId;
      const categoryBrandRelations = await getApplyBrandConfig({ categoryId, baseItemId: this.baseItemId, shopType: PLATFORMID });

      let valueMap = {};
      let newVal = [];
      this.shopList.forEach(shop => {
        const shopId = shop.id;
        let relations = (categoryBrandRelations.find(item => shopId == item.shopId) || {}).relations || [];
        let valueItem = relations.find(item => item.categoryId == categoryId);
        let isExistValueItem = []
        for(let shopId in this.valueMap){
          if(this.valueMap[shopId].vvalue){
            isExistValueItem.push(shopId)
          }
        }
        if (valueItem && !isExistValueItem.includes(String(shop.id))) {
        // if (valueItem) {
          let newItem = {
            vid: valueItem.vid,
            vvalue: valueItem.vvalue,
            categoryId: valueItem.categoryId,
            shopId,
            valueUnit: valueItem.valueUnit || '',
            refPid: valueItem.refPid || '',
          };
          valueMap[shopId] = newItem;
          newVal.push(newItem);
        }
      });

      // 新增逻辑：检查是否有未匹配的 shopId
      const unmatchedShopIds = this.shopList
        .map(shop => shop.id)
        .filter(shopId => !categoryBrandRelations.some(item => item.shopId == shopId && item.relations.find(item=>item.categoryId == categoryId)));

      if (unmatchedShopIds.length > 0) {
        // 调用 getApplyToOtherShop 接口获取数据
        const res = await this.getApplyToOtherShop({
          shopType: PLATFORMID,
          shopIds: unmatchedShopIds.join(','),
          categoryId: (this.categoryId),
        });
        // 将返回的数据进行匹配
        res &&  Object.keys(res).forEach(shopId => {
          const shopData = res[shopId];
          // 返回的品牌数据 修改需要过滤掉页面上已经有品牌设置的数据
          if(Object.keys(this.valueMap).includes(shopId) && (this.valueMap[shopId]['vvalue'])) return
          if (shopData) {
            const newItem = {
              vid: shopData.vid,
              vvalue: shopData.vvalue,
              categoryId: Number(categoryId),
              shopId: shopId,
              valueUnit: shopData.valueUnit || '',
              refPid: shopData.refPid || '',
            };
            valueMap[shopId] = newItem;
            newVal.push(newItem);
          }
        });
      }
      
      const _valueMap = Object.assign({},this.valueMap,valueMap)
      // console.log(_valueMap,350,newVal);
      // 对类目外品牌设置和品牌设置数据进行整合，
      Object.keys(_valueMap).forEach(shopId => {
        if (!valueMap[shopId]) {
          _valueMap[shopId] = _valueMap[shopId];
          newVal.push(_valueMap[shopId]);
        }
      })
      this.$set(this, 'valueMap', _valueMap);
      // 深拷贝newVal，避免父组件与子组件数据产生引用关系
      this.$emit('change', JSON.parse(JSON.stringify(newVal)));
    },
    handleSetToShop(promiseConf,applyShopName){
      this.applyShopObj = promiseConf
      this.shopDialogVisible = true;
      this.applyShopName = applyShopName
    },
    async handleRefreshBrand(item){
      const res = await refreshBrand({
        userId: item.userId,
        categoryId:this.categoryId
      })
      if(res) {
        this.$message.success('更新品牌成功！')
      }
    },
    confirmSelectShop(shops){
      this.shopDialogVisible = false
      this.$confirm(`选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
      }).then(async() => {
        const shopIds = shops.map(item=>item.id)
        const params = {
            shopType:PLATFORMID,
            shopIds:shopIds.join(','),
            categoryId: this.categoryId,
            brandName:this.applyShopName && this.applyShopName.includes('/')? this.applyShopName.split('/')[1]:this.applyShopName || ''
          }
          const res = await this.getApplyToOtherShop(params)
          const dataKeys = Object.keys(res)
          // for(const key in this.valueMap){
          //   if(dataKeys.includes((key))){
          //     const shopInfo = res[key];
          //     this.valueMap[key] = {...shopInfo,shopId: key}
          //   }
            
          // }
          for(const key in res){
              const shopInfo = res[key];
              this.valueMap[key] = { ...shopInfo,shopId: key }
          }
          this.$message.success('更新品牌成功！')
        }).catch(() => {
          // this.$message.error('更新品牌失败！')
        });
    },
    async getApplyToOtherShop(payload){
      const params = {
        ...payload,
      }
      const res =  await ApplyToOtherShop(params)
      return res
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.brandIdBlock {
  ::v-deep .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      position: unset;
    }
  }

  ::v-deep .el-image {
    display: inline-block;
    vertical-align: middle;
  }
}

.error-text {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
}
</style>